<template>
  <v-app-bar app color="#990000" height="100" class="header-bar">
    <v-toolbar-title class="headline">
      <a class="link" href="/"
        ><img
          id="lablogo"
          alt="Brand"
          src="https://firebasestorage.googleapis.com/v0/b/uscinteractionlab.appspot.com/o/logo%2Flab_logo_yellow.png?alt=media&token=9210d8a0-63b0-4c92-bf1f-bf9f27fb684e"
        />
        <span id="labname">Interaction Lab</span></a
      >
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <Menu />
    <i class="mdi mdi-menu mobile-dropdown-menu" @click="openMobileMenu" />
  </v-app-bar>
</template>

<script>
import Menu from "./Menu";

export default {
  components: {
    Menu,
  },

  methods: {
    openMobileMenu() {
      this.$store.commit("sidebar", true);
    },
  },
};
</script>

<style lang="scss">
.header-bar {
  max-width: 100vw;

  #lablogo {
    margin: 0;
    height: 50px;
    width: 45px;
  }

  #labname {
    font-family: "Raleway", sans-serif;
    font-weight: 600;
    font-size: 40px;
    color: #ffffff;
    position: relative;
    padding-left: 5px;
    letter-spacing: 1px;
  }

  .mobile-dropdown-menu {
    display: none;
  }
}

/**
 * following are responsive support
 */
@media (max-width: 768px) {
  .header-bar {
    #lablogo {
      width: 30px;
      height: 35px;
    }

    #labname {
      font-size: 30px;
      margin-left: 5px;
      top: -6px;
    }

    .mobile-dropdown-menu {
      display: block;
      color: white;
      font-size: 40px;
      position: relative;
      top: -2px;
    }
  }
}
</style>